<template>
  <div>
    <page-header :title="$t('bill.budget_alert_info_action')" />
    <page-body needMarginBottom>
      <div class="content">
        <a-row :gutter="30">
          <a-col :md="{ span: 24 }" :lg="{ span: 22 }" :xl="{ span: 16 }" :xxl="{ span: 11 }">
            <budget-alert-form ref="budgetAlertFormRef" />
          </a-col>
        </a-row>
      </div>
    </page-body>
    <page-footer>
      <div slot="right">
        <a-button class="mr-3" type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
        <a-button @click="cancel">{{$t('dialog.cancel')}}</a-button>
      </div>
    </page-footer>
  </div>
</template>

<script>
import BudgetAlertForm from '../components/form'

export default {
  components: {
    BudgetAlertForm,
  },
  data () {
    return {
      loading: false,
    }
  },
  created () {
    this.timer = null
  },
  destroyed () {
    clearTimeout(this.timer)
  },
  methods: {
    async doSubmit () {
      this.loading = true
      try {
        const { $refs: { budgetAlertFormRef } } = this
        const values = await budgetAlertFormRef.form.fc.validateFields()
        const getChannels = () => {
          return Array.from(new Set([...values.channel]))
        }
        const data = {
          alerts: [
            {
              alert_threshold_type: values.alert_threshold_type,
              alert_threshold: values.alert_threshold,
              alert_frequency: values.alert_frequency,
              user_ids: values.recipients,
              robot_ids: values.robot_ids,
              channel: getChannels(),
            },
          ],
        }
        await new this.$Manager('budgets', 'v1').performAction({
          data,
          id: this.$route.query.id,
          action: 'sync-alerts',
        })
      } catch (error) {
        throw error
      } finally {
        this.loading = false
      }
    },
    cancel () {
      this.$router.push('/budget')
    },
    async handleConfirm () {
      this.loading = true
      try {
        await this.doSubmit()
        this.$bus.$emit('budgetListRefresh', true)
        this.timer = setTimeout(() => {
          this.cancel()
        }, 500)
      } catch (err) {
        throw err
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
